import React from 'react';
import facebookSDKActions from '@mm/state/actions/facebookActions';
import { FacebookStaticSDK } from '@mm/state/interfaces/facebook';

type WithFacebookParser = <T>(Component: T, reInitOnChange?: boolean) => T;

const withFacebookParser: any = (Component, reInitOnChange = false) =>
  class extends React.PureComponent {
    FB?: FacebookStaticSDK;
    ref?: HTMLDivElement | null;

    async componentDidMount() {
      try {
        this.FB = await facebookSDKActions.getFacebookSDK();
        this.parse();
      } catch {}
    }

    componentWillUnmount() {
      this.FB = undefined;
      this.ref = undefined;
    }

    componentDidUpdate() {
      this.parse();
    }

    parse() {
      if (this.ref && this.FB) {
        // Customer Chat HTML plugin sucks so need to re-init FB to make it update
        if (reInitOnChange) {
          facebookSDKActions.reInit();
        } else {
          this.FB.XFBML.parse(this.ref);
        }
      }
    }

    render() {
      return (
        <div
          ref={ref => {
            this.ref = ref;
          }}
        >
          <Component {...this.props} />
        </div>
      );
    }
  };

export default withFacebookParser as WithFacebookParser;
